import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";

import { LayerAlias, UnitTypes } from "constant";
import features from "features";

const DEFAULT_INITIAL_VALUES = {
  // object_diameter: "3",
  name: ""
};

const usePointHandler = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const parseFields = useCallback((data) => {
    const { name, object_diameter, coordinates, classification } = data;
    const geo_data = {
      coordinates: Object.values(coordinates),
      type: "Point"
    };

    const additional = {
      object_diameter: object_diameter
        ? parseFloat(object_diameter)
        : undefined,
      classification
    };

    return {
      name,
      additional,
      geo_data
    };
  }, []);

  const handleAddPoint = useCallback(
    (updatedValues, onCreatePointSuccess) => {
      const fields = parseFields(updatedValues);

      dispatch(
        features.unitsManager.actions.createUnitRequest({
          params: {
            projectId: id,
            type: UnitTypes.POINT,
            alias: LayerAlias.MANUAL
          },
          fields,
          onSuccess: () => {
            dispatch(features.modal.actions.hideModal());
            onCreatePointSuccess();
            toastr.success(`Done`, `Point created`);
          }
        })
      );
    },
    [dispatch, parseFields, id]
  );

  const createPoint = useCallback(
    ({ onCreatePointSuccess, coordinates }) => {
      dispatch(
        features.unitsManager.actions.fetchUnitsClassificationsRequest({
          onSuccess: (res) => {
            dispatch(
              features.modal.actions.showModal({
                modalType: "CLASSIFICATION_POINT_MODAL",
                modalProps: {
                  title: "Add point",
                  description:
                    "Add a description or mark the coordinates for a more precise location.",
                  pointsLayerAlias: LayerAlias.MANUAL,
                  currentClassificationData: {},
                  generalPointData: { ...DEFAULT_INITIAL_VALUES, coordinates },
                  classificationsData: res.data[0],
                  params: res.params,
                  onSubmit: (values) =>
                    handleAddPoint(values, onCreatePointSuccess)
                }
              })
            );
          }
        })
      );
    },
    [dispatch, handleAddPoint]
  );

  return { createPoint };
};

export default usePointHandler;
